import { render, staticRenderFns } from "./node-list-carousel-slagbib-booking-slide.vue?vue&type=template&id=03205956"
import script from "./node-list-carousel-slagbib-booking-slide.vue?vue&type=script&lang=js"
export * from "./node-list-carousel-slagbib-booking-slide.vue?vue&type=script&lang=js"
import style0 from "../../core/ck-editor.less?vue&type=style&index=0&prod&lang=less&external"
import style1 from "../../core/icons.less?vue&type=style&index=1&prod&lang=less&external"
import style2 from "./node-list-carousel-slagbib-booking-slide.less?vue&type=style&index=2&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports